import io from "socket.io-client";
import Helper from "./helpers";

class SocketAPI {
  constructor() {
    this.socket = null;
    this.listeners = new Set();
  }

  connect() {
    this.socket = io(`${process.env.REACT_APP_WEB_SOCKET_URL}/room_chat`, {
      auth: {
        token: Helper.getAuthToken(),
      },
    });

    // Notify listeners on connect
    this.socket.on("connect", () => {
      this.notifyListeners();
    });

    return new Promise((resolve, reject) => {
      this.socket.on("connect", () => {
        resolve();
      });
      this.socket.on("connect_error", (error) => reject(error));
    });
  }

  disconnect() {
    return new Promise((resolve) => {
      this.socket?.disconnect(() => {
        this.socket = null;
        this.notifyListeners();
        resolve();
      });
    });
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notifyListeners() {
    this.listeners.forEach((cb) => cb(this.socket));
  }

  getSocket() {
    return this.socket;
  }
}

export default new SocketAPI();
